/* eslint-disable max-len */
import { Logo } from '../Logo'
import styles from './TopLogo.module.scss'

/* eslint-disable react/no-unknown-property */
const TopLogo = () => (
  <div className={styles.topLogoContainer}>
    <div className={styles.logo}>
      <Logo />
    </div>
    <p className={styles.quote}>Mental health designed to help <i className={styles.yellowQuote}> you</i> shine</p>
  </div>
)

export default TopLogo
